import React, { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import styled from 'styled-components';
import { theme } from 'styles';

interface TextEditorProps {
  value?: string;
  onChange?: (v: string) => void;
  placeholder?: string;
  preserveWhitespace?: boolean;
  width?: number;
  'data-cy'?: string;
}

const SReactQuill = styled(ReactQuill)<{ width: number }>`
  width: ${({ width }) => `${width}px`};

  .ql-tooltip {
    left: 0 !important;
  }
`;

const TextEditor = ({
  value = '',
  onChange,
  placeholder,
  preserveWhitespace = false,
  width = 200,
  'data-cy': dataCy,
}: TextEditorProps) => {
  const [val, setVal] = useState(value);
  const internalValueRef = useRef(value);

  useEffect(() => {
    if (value !== internalValueRef.current) {
      setVal(value);
      internalValueRef.current = value;
    }
  }, [value]);

  const modules = {
    toolbar: [
      ['bold', 'underline'],
      [
        {
          color: [
            theme.color.brand_black,
            theme.color.brand,
            theme.color.white,
            theme.color.grey80,
            theme.color.grey60,
            theme.color.grey40,
            theme.color.grey20,
            theme.color.clear_blue,
            theme.color.ice_blue,
            theme.color.palette_green_7,
            theme.color.off_white,
            theme.color.warning,
            theme.color.palette_red_1,
            theme.color.palette_red_7,
          ],
        },
      ],
      ['link'],
    ],
  };

  return (
    <div data-cy={dataCy}>
      <SReactQuill
        width={width}
        value={val}
        placeholder={placeholder}
        onChange={(e) => {
          internalValueRef.current = e;
          setVal(e);
          onChange?.(e);
        }}
        modules={modules}
        preserveWhitespace={preserveWhitespace}
      />
    </div>
  );
};

export default TextEditor;
